/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostListener,
  OnInit
} from '@angular/core';
import {
  Router,
  ActivatedRoute,
  NavigationEnd,
  QueryParamsHandling
} from '@angular/router';
import {
  REPORT_CONFIG,
  ReportConfig,
  MainFilterItem,
  FilterOption,
  GridHeader,
  APP_MAIN_FILTERS,
  CTV_MAIN_FILTERS,
  DOMAIN_MAIN_FILTERS
} from './REPORT_CONFIG';
import { AppService } from '../../../services/app-service';
import { DomainService } from '../../../services/domain-service';
import {
  DAY_STRINGS,
  TabbedFilterGroup,
  TabbedFilterItemValue
} from './TABBED_FILTERS_CONFIG';
import { DropdownSelectItem } from './DropdownSelectItem';
import { UtilFunctions } from '../util-functions';
import { User } from '../../../models/User';
import { EventBusService } from '../../../services/EventBusService';
import { ClearFilterService } from '../../../services/clear-filter.service';
import { CANNED_REPORTS } from './CANNED_REPORTS_CONFIG';
import {
  APP_TOP_LEVEL_CATEGORIES,
  AppTopLevelCategory
} from './APP_TABBED_FILTERS_CONFIG';
import { ParamMap, KeyLabel } from './models/discovery.models';
import { DatePipe } from '@angular/common';
import { DiscoveryService } from './services/discovery-service';
import { DiscoveryUtilFunctions } from './discovery-util-functions';
import { CtvService } from '../../../services/ctv-service';
import { CTV_CANNED_REPORTS } from './CTV_CANNED_REPORTS_CONFIG';
import { UrlfixPipe } from '../../../pipes/urlfix.pipe';
import { WatchlistService } from '../../../services/watchlist-service';
import { Subscription } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { AppNavigationService } from '../../../services/app-navigation.service';
import { AuthService, AuthState } from 'app/services/auth.service';
import { TrackingService } from 'app/services/tracking.service';
import { PageMetaService } from 'app/services/page-meta.service';
import { NotificationService } from 'app/services/notification.service';
import { NotificationSettings } from 'app/models/notification-settings';

var validator = require('validator');

export const LOCALSTORAGE_KEY = 'pix-imported-csv-columns'; // APPS LS
export const LOCALSTORAGE_KEY_DOMAINS = 'pix-imported-csv-columns-domains'; // DOMAINS LS

declare var jQuery: any;
declare var toastr: any;

@Component({
  selector: 'app-new-discovery',
  templateUrl: './discovery.component.html',
  styleUrls: [
    './discovery.component.scss',
    './discovery-responsive.component.scss'
  ]
})
export class DiscoveryComponent implements OnInit {
  currentConfig: ReportConfig;
  tabbedGroups: TabbedFilterGroup[] = [];
  selectedTabbedGroup: TabbedFilterGroup;
  currentSearchFilter: string;
  gridData = [];
  loadingData: boolean;
  showDetails: boolean;
  hideAdvancedFilters: boolean;
  reportConfigs: Array<ReportConfig>;
  selectedFilterValues: TabbedFilterItemValue[] = [];
  isInited = false;
  noFacets = false;
  totalCount: number;
  facets: any = {};
  showLoadMore: boolean;
  showLoadingMore: boolean;
  notAllowed: boolean;
  currentMonthLabel: string;
  cannedreports: Array<any>;
  currentCannedReport: any;
  reportViewType = 'dashboard';
  topLevelCategories: AppTopLevelCategory[] = APP_TOP_LEVEL_CATEGORIES;
  bulkUploadReportId: string;
  withCsvImportPermission: boolean;
  remainingQuota: number;
  actualRemainingQuota: number;
  quotaCount: number;
  startDateNum: number;
  quotaStartDate: string;
  quotaEndDate: string;
  datePipe = new DatePipe('en-US');
  urlfixPipe = new UrlfixPipe();
  showQuotaExceeded: boolean;
  uploadingCsv: boolean;
  errorMessage: string;
  showServerError: boolean;
  currentQuota: number;
  consumedQuota: number;
  filterStrings: Array<string>;
  showImportProgress: boolean;
  importErrorMessage: string;
  importStartMap: Map<string, number> = new Map();
  importErrorButtonText = 'OK';
  maxTimeout = 30 * 60000; // Timeout check with 30mins max

  savingPreset: boolean;
  importedFileName: string;
  notFoundCount;
  notFoundList;
  notFoundListUri: string;
  notFoundConfigKey: string;
  notFoundListHTML: string;
  savedPresetTitle: string;

  downloadColumns: Array<KeyLabel> = new Array(0);
  canDownloadCSV: boolean;
  downloadButtonDisabled: boolean;
  showSavePreset: boolean;
  showImportParam: boolean;

  hideUnfilteredDownloadCsv: boolean;

  importCsvRemoveDuplicates: boolean;
  showFollowing: boolean;
  followingCount: number;

  noMatchingConfig: boolean;
  notificationSettings: Array<NotificationSettings>;

  get isFreemium(): boolean {
    return this._userService.isFreemium();
  }

  currentCannedReportUpdater: EventEmitter<any> = new EventEmitter<any>();
  importedFileNameUpdater: EventEmitter<string> = new EventEmitter<string>();
  facetsUpdater: EventEmitter<any> = new EventEmitter<any>();
  routeFilterValuesUpdater: EventEmitter<any> = new EventEmitter<any>();
  foundFiltersUpdater: EventEmitter<any> = new EventEmitter<any>();
  searchInputValueUpdater: EventEmitter<string> = new EventEmitter<string>();
  routeRefreshUpdater: EventEmitter<any> = new EventEmitter<any>();
  importStatusInvoker: EventEmitter<string> = new EventEmitter<string>();
  refreshDataInvoker: EventEmitter<boolean> = new EventEmitter<boolean>();
  clearAppGlobalSearchInputInvoker: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  onDropdownFilterSelectInvoker: EventEmitter<any> = new EventEmitter<any>();
  showOptionsInvoker: EventEmitter<any> = new EventEmitter<any>();
  importListInvoker: EventEmitter<boolean> = new EventEmitter<boolean>();
  presetsListInvoker: EventEmitter<boolean> = new EventEmitter<boolean>();
  prepareFiltersInvoker: EventEmitter<boolean> = new EventEmitter<boolean>();

  watchlistTypeMapping = {
    apps: 'app',
    domains: 'domain',
    ctv: 'ctv'
  };

  followIdMapping = {
    apps: 'appId',
    domains: 'adDomain',
    ctv: 'appId'
  };

  selectedImportParams = {
    ctv: {},
    apps: {},
    domains: {}
  };

  appGlobalSearchParam: string;
  appGlobalSearchParamModel: string;
  mobileBreakPoint: any;
  private _onAuthStateChange: Subscription;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _appService: AppService,
    private _domainService: DomainService,
    private _ctvService: CtvService,
    public _userService: User,
    private _clearFilterService: ClearFilterService,
    public _eventService: EventBusService,
    private _tracking: TrackingService,
    private _auth: AuthService,
    private _discoveryService: DiscoveryService,
    private _watchlistService: WatchlistService,
    private _notificationService: NotificationService,
    private _title: Title,
    private _appnavService: AppNavigationService,
    private _changeDetector: ChangeDetectorRef,
    private pageMeta: PageMetaService
  ) {
    this._onAuthStateChange = this._auth.onAuthStateChange.subscribe(evt =>
      this.onAuthStateChange(evt)
    );
  }

  ngOnInit(): void {
    // Load report configs
    this.reportConfigs = this._discoveryService.generateReportConfigs();

    // Get View type, current options are dashboard and list
    const viewtype = this._route.snapshot.params['viewtype'];
    if (viewtype) {
      this.reportViewType = viewtype;
    }

    // TODO: do we need this as config in API?
    this.hideUnfilteredDownloadCsv =
      this._userService.getSessionScope() === 'pbm';

    // EventEmitters
    this.currentCannedReportUpdater.subscribe(value => {
      this.currentCannedReport = value;
    });

    this.importedFileNameUpdater.subscribe(value => {
      this.importedFileName = value;
    });

    this.facetsUpdater.subscribe(value => {
      this.facets[value.param] = value.mapping;
    });

    this.routeFilterValuesUpdater.subscribe(value => {
      this.routeWithFilterValues(value);
    });

    this.routeRefreshUpdater.subscribe(value => {
      if (value != null) {
        this.routeRefresh(value.additionalQueryParams);
      } else {
        this.routeRefresh({});
      }
    });

    this.importStatusInvoker.subscribe(value => {
      this.getImportStatus(value);
    });

    this.refreshDataInvoker.subscribe(value => {
      this.refreshData();
    });

    this.clearAppGlobalSearchInputInvoker.subscribe(value => {
      this.appGlobalSearchParamModel = null;
      this.appGlobalSearchParam = null;
    });

    this.noMatchingConfig = false;

    if (!this._userService.isFreemium()) {
      // Check for proper discovery type, current options are apps, domains
      const discoverytype = this._route.snapshot.params['discoverytype'];
      const foundConfig = REPORT_CONFIG.filter(
        config => config.key === discoverytype
      )[0];
      if (foundConfig) {
        if (this._userService.hasPermission(foundConfig.permission)) {
          this.discoveryTypeClick(foundConfig);
          this.autoHidePtiRankColumn();
        } else {
          const forwardConfig = REPORT_CONFIG.filter(
            config => config.key !== discoverytype
          )[0];
          if (this._userService.hasPermission(forwardConfig.permission)) {
            this.discoveryTypeClick(forwardConfig);
            this.autoHidePtiRankColumn();
          } else {
            this._eventService.showPopupEvent.emit(true);

            if (
              this._userService.appEnabled() ||
              this._userService.domainEnabled()
            ) {
              this._router.navigate(['/insight']);
            } else if (this._userService.rankingsEnabled()) {
              // Rankings
              this._router.navigate(['/rankings']);
            }
          }
        }
      } else {
        this._router.navigate(['/discovery'], {
          replaceUrl: true,
          queryParams: this._route.snapshot.queryParams
        }); // allow discovery-page-routing to take appropriate routing
      }
    } else {
      this.noMatchingConfig = true;
    }

    this._eventService.watchlistUpdate.subscribe(value => {
      this.updateNumFollowing();
      this.gridData = [];
      this.loadDiscoveryData();
    });

    void this._notificationService.getAllNotificationSettings().then(data => {
      this.notificationSettings = data;
    });

    this.updatePageTitle();
    this._appnavService.setSelected('nav-discovery');
    this._appnavService.setIsMrtSearch(undefined);
    this._router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.refreshData();
      }
    });
    this.mobileBreakPoint = window.matchMedia('(max-width: 576px)');

    this.loadFilterStats();
  }

  ngOnDestroy() {
    if (this._onAuthStateChange) {
      this._onAuthStateChange.unsubscribe();
    }
  }

  onAuthStateChange(evt: AuthState) {
    this._changeDetector.detectChanges();
  }

  initializeQueryFilters(): void {
    if (this.currentConfig) {
      const nfoundConfig = [];
      nfoundConfig.push(this.currentConfig);
      this._discoveryService.deselectAllFilters(nfoundConfig[0]);
      this.selectedFilterValues = [];
      const queryParams = this._route.snapshot.queryParams;
      Object.keys(queryParams).forEach(key => {
        if (
          key !== 'sort' &&
          key !== 'bulkUploadReportId' &&
          key !== 'showFollowing' &&
          key !== 'appGlobalSearchParam' &&
          key != 'includeSpoofing'
        ) {
          const foundItem = this._discoveryService.selectFilterFromKey(
            nfoundConfig[0],
            key
          );
          if (foundItem && foundItem.param) {
            const label = foundItem ? foundItem.label : null;

            const queryValue = queryParams[key];
            let values = [queryValue];
            if (foundItem.multiple) {
              values = this._discoveryService.generateMultipleValues(
                queryValue,
                foundItem
              );
            }

            foundItem.options.forEach(option => (option.selected = false));

            values.forEach(v => {
              let valueLabel = v;
              let value = v;
              if (foundItem.type === 'range') {
                const rangeValue = v.replace('[', '').replace(']', '');
                valueLabel = rangeValue.replace(',', ' - ');
                value = `[${rangeValue}]`;

                this._discoveryService.initializeRangeValue(
                  rangeValue,
                  foundItem
                );
              }

              if (foundItem.options && foundItem.options.length > 0) {
                const foundOption = foundItem.options.filter(
                  option => option.value === v
                )[0];
                if (foundOption) {
                  foundOption.selected = true;
                  valueLabel = foundOption.text
                    ? foundOption.text
                    : foundOption.name;
                }
              }

              if (foundItem.type === 'range') {
                valueLabel =
                  this._discoveryService.generateRangeValue(foundItem);
              } else {
                if (valueLabel.indexOf('_') >= 0) {
                  valueLabel = valueLabel.split('_').join(' ');
                }
              }

              const foundOption = foundItem.options.filter(
                option => option.value === value
              )[0];
              if (foundOption) {
                foundOption.selected = true;
              }

              const filterValue = {
                param: key,
                value: value,
                label: label,
                valueLabel: valueLabel
              };

              if (filterValue.param === 'dayOfWeek') {
                filterValue.valueLabel = DAY_STRINGS[Number.parseInt(value)];
              }

              if (
                this.currentConfig.key === 'ctv' &&
                filterValue.param === 'category'
              ) {
                const deviceFilter = this.currentConfig.mainFilterItems.filter(
                  mainFilter => mainFilter.apiKey === 'device'
                )[0];
                const osLabel = {
                  roku: 'Roku',
                  firetv: 'Fire TV',
                  samsung: 'Samsung',
                  tvos: 'tvOS'
                };
                filterValue.label = `${
                  osLabel[deviceFilter.selected.value]
                } Store Categories`;
              }

              this.selectedFilterValues.push(filterValue);
            });
          } else {
          }
        } else if (key === 'sort') {
          const sortArray = queryParams[key].split(',');
          nfoundConfig[0].gridHeaders.forEach(header => {
            header.sort = null;
          });
          sortArray.forEach(sortValue => {
            const val: string[] = sortValue.split(' ');
            let sort = 'asc';
            if (val && val.length > 1 && val[1] === 'DESC') {
              sort = 'desc';
            }
            const headerFound = nfoundConfig[0].gridHeaders.filter(
              header => header.key === val[0]
            );
            if (headerFound && headerFound.length > 0) {
              headerFound[0].sort = sort;
            }
          });
        } else if (key === 'bulkUploadReportId') {
          if (
            nfoundConfig &&
            nfoundConfig[0] &&
            this.bulkUploadReportId !== queryParams[key]
          ) {
            this.bulkUploadReportId = queryParams[key];
          }
        } else if (key === 'showFollowing') {
          this.showFollowing = queryParams[key] === 'true';
        } else if (key === 'appGlobalSearchParam') {
          this.appGlobalSearchParam = queryParams[key];
          this.appGlobalSearchParamModel = queryParams[key];
        }
      });
    }

    this.updatePageTitle();
  }

  recalculateSideFilterNav() {
    let widthPx = '0px';
    if (jQuery('.precanned-reports-cont').hasClass('show')) {
      widthPx = jQuery(window).width() + 'px';
    }
    jQuery('.precanned-reports-cont').css('width', widthPx);
  }

  toggleMobileSideNav() {
    jQuery('.precanned-reports-cont').toggleClass('show');
    setTimeout(() => {
      this.recalculateSideFilterNav();
    });
  }

  @HostListener('window:resize')
  onWindowResize() {
    if (!this.mobileBreakPoint.matches) {
      jQuery('.precanned-reports-cont').css('width', '');
    } else {
      this.recalculateSideFilterNav();
    }
  }

  showSavePresetClick() {
    this.showSavePreset = true;
    this.savedPresetTitle = '';
    jQuery('.save-preset input').val('');
    setTimeout(() => {
      jQuery('.save-preset input').focus();
    }, 500);
  }

  toggleAdvancedFilters() {
    this.hideAdvancedFilters = !this.hideAdvancedFilters;
  }

  discoveryTypeClick(selectedConfig: ReportConfig) {
    // Initialize Searching of Filters
    this.foundFiltersUpdater.emit(null);
    this.searchInputValueUpdater.emit(null);

    // Check if it's still loading or not and the previous config loaded is not the same to avoid double loading
    if (
      !this.loadingData &&
      (!this.currentConfig || this.currentConfig.key !== selectedConfig.key)
    ) {
      // Generate config
      const foundConfig = REPORT_CONFIG.filter(
        config => config.key === selectedConfig.key
      )[0];
      const currentConfig: ReportConfig = {
        key: selectedConfig.key,
        title: selectedConfig.title,
        viewDetailsText: selectedConfig.viewDetailsText,
        mainFilterItems: [],
        permission: foundConfig.permission,
        gridHeaders: foundConfig.gridHeaders,
        topLevelCategories: foundConfig.topLevelCategories,
        dashboardViewConfig: foundConfig.dashboardViewConfig,
        importParams: foundConfig.importParams
      };

      this._userService.setCurrentInsightsKey(selectedConfig.key);

      // Check for permission
      if (this._userService.hasPermission(currentConfig.permission)) {
        this.currentConfig = currentConfig;

        // Check for Download CSV Permissions
        if (this.currentConfig.key !== 'ctv') {
          this.canDownloadCSV = true;
        } else if (
          this.currentConfig.key === 'ctv' &&
          this._userService.ottDownloadCsvEnabled()
        ) {
          this.canDownloadCSV = true;
        } else {
          this.canDownloadCSV = false;
        }

        // Load canned reports or predefined filters
        this.loadCannedReports();

        // Grid Header permissions checking
        this.currentConfig.gridHeaders.forEach(gridHeader => {
          if (gridHeader.permission) {
            if (!this._userService.hasPermission(gridHeader.permission)) {
              gridHeader.hidden = true;
            }
          }
        });

        // Side Navigation checking
        this.currentConfig.topLevelCategories.forEach(topLevelCategory => {
          if (topLevelCategory.permission) {
            if (!this._userService.hasPermission(topLevelCategory.permission)) {
              topLevelCategory.hidden = true;
              return;
            }
          }

          topLevelCategory.groups.forEach(tabbedGroup => {
            tabbedGroup.items.forEach(item => {
              if (item.permission) {
                if (!this._userService.hasPermission(item.permission)) {
                  item.hidden = true;
                }
              }
            });
          });
        });

        // Enable loading data status
        this.loadingData = true;
        this.notAllowed = false;

        // Initialize Main Filter Items
        foundConfig.mainFilterItems.forEach(mainFilterItem => {
          const snapshot = this._route.snapshot;
          let mainFilterItemValue = snapshot.params[mainFilterItem.key];
          if (!mainFilterItemValue)
            mainFilterItemValue = snapshot.queryParams[mainFilterItem.apiKey];

          let isValidMainFilterValue = false;
          const foundOption = mainFilterItem.options.filter(
            o => o.value === mainFilterItemValue
          )[0];
          if (foundOption) {
            isValidMainFilterValue = true;
          }

          const pushMainFilterItem: MainFilterItem = {
            key: mainFilterItem.key,
            apiKey: mainFilterItem.apiKey,
            label: mainFilterItem.label,
            type: mainFilterItem.type,
            hidden: mainFilterItem.hidden,
            ignore: mainFilterItem.ignore,
            position: mainFilterItem.position,
            selected: null,
            options: []
          };

          mainFilterItem.options.forEach(option => {
            let isSelected = option.selected;
            if (isValidMainFilterValue) {
              // We override selected if passed param filter value is valid
              isSelected = option.value === mainFilterItemValue;
            }
            const pushOption: FilterOption = {
              apiValue: option.apiValue,
              value: option.value,
              label: option.label,
              selected: isSelected,
              hidden: option.hidden ? true : false,
              ignore: option.ignore ? true : false
            };
            if (isSelected) {
              pushMainFilterItem.selected = pushOption;
            }
            pushMainFilterItem.options.push(pushOption);
          });

          currentConfig.mainFilterItems.push(pushMainFilterItem);
        });

        // this.selectTab(this.currentConfig.tabbedGroups[0]);

        setTimeout(() => {
          jQuery('.right-content.discovery').removeClass('key-apps');
          jQuery('.right-content.discovery').removeClass('key-domains');
          jQuery('.right-content.discovery').removeClass('key-ctv');
          jQuery('.right-content.discovery').addClass(
            'key-' + currentConfig.key
          );
        }, 100);

        // If switching to a different type we clear the search input
        if (this.currentConfig.key !== 'apps') {
          this.appGlobalSearchParamModel = null;
          this.appGlobalSearchParam = null;
        }

        if (this.isInited) {
          if (this.showFollowing) {
            this.followingClick();
          } else {
            this.routeRefresh({});
          }
        } else {
          this.bulkUploadReportId =
            this._route.snapshot.queryParams['bulkUploadReportId'];
          if (this.bulkUploadReportId) {
            this.getImportStatus(this.bulkUploadReportId);
          } else if (this.showFollowing) {
            this.followingClick();
          } else {
            this.refreshData();
          }
        }
        this.isInited = true;
      } else {
        this._eventService.showPopupEvent.emit(true);
      }
    }
  }

  loadCannedReports() {
    if (this.currentConfig.key === 'apps') {
      this.cannedreports = CANNED_REPORTS;
    } else if (this.currentConfig.key === 'ctv') {
      this.cannedreports = CTV_CANNED_REPORTS;
    } else {
      this.cannedreports = [];
    }
  }

  mainFilterToggleClick(mainFilterItem: MainFilterItem) {
    var selected = mainFilterItem.selected;

    var target = selected.value === 'T' ? 'F' : 'T';

    mainFilterItem.options.forEach(o => {
      o.selected = o.value === target;
      if (o.selected) {
        mainFilterItem.selected = o;
      }
    });

    this.showDetails = false;
    this._appService.excludeFacetParam = null;
    this.routeRefresh({}, 'merge');
  }

  mainFilterOptionClick(
    mainFilterItem: MainFilterItem,
    filterOption: FilterOption
  ) {
    this.foundFiltersUpdater.emit(null);
    this.searchInputValueUpdater.emit(null);
    const bulkUploadReportId =
      this._route.snapshot.queryParams['bulkUploadReportId'];

    if (this.currentConfig.key === 'apps') {
      if (mainFilterItem.apiKey === 'region') {
        const goingToGlobal = filterOption.apiValue === 'GLOBAL';

        this.updatePtiRankColumn(goingToGlobal, !!bulkUploadReportId);
      }
    }

    if (
      mainFilterItem.selected.value !== filterOption.value ||
      bulkUploadReportId
    ) {
      if (
        mainFilterItem.apiKey === 'appStore' ||
        mainFilterItem.apiKey === 'device'
      ) {
        if (mainFilterItem.selected.value === filterOption.value) {
          // We have to set the filterOption selected as all
          const allOption = mainFilterItem.options.filter(
            option => option.value === 'all'
          );
          filterOption = allOption[0];
        }
      }

      mainFilterItem.options.forEach(option => {
        option.selected = filterOption.value === option.value;
        if (option.selected) {
          mainFilterItem.selected = option;
        }
      });

      this.showDetails = false;
      this._appService.excludeFacetParam = null;
      this.routeRefresh({}, 'merge');
    }
  }

  autoHidePtiRankColumn() {
    const routeParams = this._route.snapshot.params;
    const isBulkUpload = !!this._route.snapshot.queryParams.bulkUploadReportId;
    if (routeParams.discoverytype === 'apps') {
      this.updatePtiRankColumn(routeParams.param3 === 'GLOBAL', isBulkUpload);
    }
  }

  updatePtiRankColumn(isGlobal: boolean, isCustomReport: boolean) {
    const inventory = this.currentConfig.gridHeaders.find(
      header => header.key === 'inventory'
    );
    const ptiRank = this.currentConfig.gridHeaders.find(
      header => header.key === 'ptiRank'
    );

    if (isGlobal) {
      // ptiRank hiding
      ptiRank.hidden = true;

      if (ptiRank.sort) {
        inventory.sort = ptiRank.sort === 'sort-asc' ? 'sort-desc' : 'sort-asc';
        ptiRank.sort = '';
      }
    } else {
      if (isCustomReport) {
        ptiRank.hidden = true;

        if (ptiRank.sort) {
          inventory.sort =
            ptiRank.sort === 'sort-asc' ? 'sort-desc' : 'sort-asc';
          ptiRank.sort = '';
        }
      } else {
        ptiRank.hidden = false;

        if (inventory.sort) {
          ptiRank.sort =
            inventory.sort === 'sort-asc' ? 'sort-desc' : 'sort-asc';
          inventory.sort = '';
        }
      }
    }
  }

  reportViewTypeClick(reportViewType: string) {
    this.reportViewType = reportViewType;
    this.routeRefresh({}, 'preserve');
  }

  appGlobalSearch(appGlobalSearchParamModel?: any) {
    this.appGlobalSearchParamModel = appGlobalSearchParamModel;
    if (this.appGlobalSearchParam !== this.appGlobalSearchParamModel) {
      this.appGlobalSearchParam = this.appGlobalSearchParamModel;
      const queryParams = {
        appGlobalSearchParam:
          this.appGlobalSearchParam && this.appGlobalSearchParam
            ? this.appGlobalSearchParam
            : null
      };
      const currentQueryParams = this._route.snapshot.queryParams;
      if (currentQueryParams && Object.keys(currentQueryParams).length > 0) {
        Object.keys(currentQueryParams)
          .filter(key => key !== 'appGlobalSearchParam')
          .forEach(key => {
            queryParams[key] = currentQueryParams[key];
          });
      }
      this.routeRefresh(queryParams);
    }
  }

  clearAppGlobalSearch() {
    this.appGlobalSearchParamModel = null;
    this.appGlobalSearch();
  }

  routeRefresh(
    additionalQueryParams: ParamMap,
    handling: QueryParamsHandling = ''
  ) {
    if (
      additionalQueryParams['showFollowing'] ||
      additionalQueryParams['appGlobalSearchParam']
    ) {
      this.reportViewType = 'list';
    }
    const routeParams: Array<string> = [
      '/discovery',
      this.currentConfig.key,
      this.reportViewType
    ];
    const addParams: string[] = [];

    this.currentConfig.mainFilterItems.forEach(item => {
      if (item.position === 'query') {
        additionalQueryParams[item.apiKey] = item.selected.value;
      } else {
        addParams.push(item.selected.value);
      }
    });

    // const addParams: Array<string> = this.currentConfig.mainFilterItems.map(item => { return item.selected.value; });
    this._router.navigate(routeParams.concat(addParams), {
      queryParams: additionalQueryParams,
      queryParamsHandling: handling
    });
  }

  refreshData() {
    const discoverytype = this._route.snapshot.params['discoverytype'];
    const foundConfig = REPORT_CONFIG.filter(
      config => config.key === discoverytype
    )[0];

    this.autoHidePtiRankColumn();

    if (this.currentConfig.key !== foundConfig.key) {
      this.isInited = false;
      this.discoveryTypeClick(foundConfig);
    } else {
      this.gridData = [];
      this.showLoadingMore = false;
      this.showLoadMore = false;
      setTimeout(() => {
        // Initialize filters form Query Params
        this.initializeQueryFilters();
        this.loadDiscoveryData();
      }, 100);
      setTimeout(() => {
        this.prepareFiltersInvoker.emit(true);
      }, 200);
    }
  }

  imageErrorListen() {
    setTimeout(() => {
      jQuery('.trusted-seller img').on('error', function () {
        console.log('>>>>>>>> ERROR IMG: ' + this.src);
        this.style.display = 'none';
      });

      jQuery('img.appIcon').on('error', function () {
        console.log('>>>>>>>> ERROR IMG: ' + this.src);
        this.style.opacity = 0;
      });
    });
  }

  getFilterStrings(noMainFilters?: boolean, noSortBy?: boolean) {
    const bulkUploadReportId =
      this._route.snapshot.queryParams['bulkUploadReportId'];
    const filterStrings = DiscoveryUtilFunctions.getFilterStrings(
      this.currentConfig,
      this.selectedFilterValues,
      this.cannedreports,
      bulkUploadReportId,
      this.currentCannedReportUpdater,
      this.importedFileNameUpdater,
      noMainFilters,
      noSortBy
    );

    this.filterStrings = filterStrings;
    return filterStrings;
  }

  processAppsResponse(
    response: any,
    filterString: string,
    initialLoad: boolean
  ) {
    if (!response['docs'] || this.currentSearchFilter != filterString) {
      return;
    }
    if (initialLoad) {
      this.gridData = [];
    }
    this.gridData = this.gridData.concat(
      this.prepareAppsData(response['docs'])
    );
    this.totalCount = response['numFound'];
    this.showLoadMore = this.gridData.length < this.totalCount;
    this.showLoadingMore = false;
    setTimeout(() => {
      this.loadingData = false;
    }, 500);
    this.initAppHovers();
    this.initTooltips();
    if (this.currentConfig.key === 'apps') {
      this.initAppLinks();
    } else if (this.currentConfig.key === 'domains') {
      this.initDomainLinks();
    } else if (this.currentConfig.key === 'ctv') {
      this.initCtvLinks();
    }
    this.initDiscoveryLinks();
    this.imageErrorListen();
    this.initGridHeaders();
  }

  processAvailableMonthsResponse(response: any) {
    if (response['availableMonths']) {
      const currentMonthLabel = response['availableMonths'][0]['label'];
      this.currentMonthLabel =
        currentMonthLabel[0] + currentMonthLabel.toLowerCase().substring(1);
    }
  }

  processReportDataResponse(response: any) {
    const exportFields = response['importExportResultFields'];
    const columnMetadata = response['reportHeader']['columnMetadata'];
    if (exportFields && columnMetadata) {
      const downloadColumns: Array<KeyLabel> = exportFields.map(field => {
        return {
          key: field,
          label: columnMetadata[field] ? columnMetadata[field].label : field,
          selected: false
        };
      });
      this.downloadColumns = downloadColumns.filter(
        column => column.key !== 'ptiRank'
      );
      this.updateSelectedDownloadColumns();
    }
  }

  updateNumFollowing() {
    if (this.currentConfig) {
      const type = this.currentConfig.key;
      const follows = this._watchlistService.watchlist.getFollowListByType(
        this.watchlistTypeMapping[type]
      );
      this.followingCount = follows.length;
    }
  }

  loadDiscoveryData(initialLoad: boolean = true) {
    const start = initialLoad ? 0 : this.gridData.length;
    const limit = this.mobileBreakPoint.matches ? 10 : 50;
    this.loadingData = true;
    const filterStrings = this.getFilterStrings();
    this.updateNumFollowing();

    const type = this.currentConfig.key;
    const follows = this._watchlistService.watchlist.getFollowListByType(
      this.watchlistTypeMapping[type]
    );
    if (this.showFollowing) {
      if (this.followingCount > 0) {
        follows.forEach(follow => {
          filterStrings.push(
            `${this.followIdMapping[type]}=${follow.followId}`
          );
        });
      } else {
        // temporary randomId to return no results
        filterStrings.push(`${this.followIdMapping[type]}=XXXX`);
      }
    }

    if (this.appGlobalSearchParam && this.appGlobalSearchParam.length > 0) {
      filterStrings.push(`appGlobalSearchParam=${this.appGlobalSearchParam}`);
    }

    if (this.showFollowing && this.reportViewType === 'dashboard') {
      this.routeRefresh({ showFollowing: 'true' });
    } else {
      if (this.showImportProgress) return; // wait for the import to complete before trying to fetch data

      const searchFilterString = filterStrings.join('&');
      this.currentSearchFilter = searchFilterString;
      this.fetchFacets();

      if (this.currentConfig.key === 'apps') {
        void this._appService
          .searchForApps(start, limit, searchFilterString)
          .then(response => {
            this.processAppsResponse(response, searchFilterString, initialLoad);
          });

        this.computeAppQuota();
        void this._appService.getAvailableMonths().then(response => {
          this.processAvailableMonthsResponse(response);
        });

        this.importListInvoker.emit(true);
        this.presetsListInvoker.emit(true);

        if (this.bulkUploadReportId) {
          void this._appService.getReportData().then(response => {
            this.processReportDataResponse(response);
          });
        }
      } else if (this.currentConfig.key === 'ctv') {
        void this._ctvService
          .searchForApps(start, limit, searchFilterString)
          .then(response => {
            this.processAppsResponse(response, searchFilterString, initialLoad);
          });

        this.computeCtvQuota();
        void this._ctvService.getAvailableMonths().then(response => {
          this.processAvailableMonthsResponse(response);
        });

        this.importListInvoker.emit(true);
        this.presetsListInvoker.emit(true);

        if (this.bulkUploadReportId) {
          const deviceFilter = this.currentConfig.mainFilterItems.filter(
            mainFilter => mainFilter.apiKey === 'device'
          )[0];
          const device = deviceFilter.selected.value;
          void this._ctvService
            .getReportData(device !== 'all' ? device : 'roku')
            .then(response => {
              this.processReportDataResponse(response);
            });
        }
      } else {
        void this._domainService
          .searchForDomains(start, limit, searchFilterString)
          .then(response => {
            this.processAppsResponse(response, searchFilterString, initialLoad);
          });

        this.computeDomainQuota();
        void this._domainService.getAvailableMonths().then(response => {
          this.processAvailableMonthsResponse(response);
        });

        this.importListInvoker.emit(true);
        this.presetsListInvoker.emit(true);

        if (this.bulkUploadReportId) {
          void this._domainService.getReportData().then(response => {
            this.processReportDataResponse(response);
          });
        }
      }
    }
  }

  loadFilterStats() {
    if (this.currentConfig.key === 'domains') {
      const filterStrings = this.getFilterStrings();
      this._domainService
        .getDomainStats(filterStrings.join('&'))
        .then(response => {
          this.currentConfig.topLevelCategories.forEach(topLevelCategory => {
            topLevelCategory.groups.forEach(tabbedGroup => {
              tabbedGroup.items.forEach(item => {
                if (item.updateMaxValue) {
                  const responseItem = response[item.param];
                  if (responseItem && item.type === 'range') {
                    item.initMaxValue = responseItem.max;
                  }
                }
              });
            });
          });
        });
    }
  }

  updateSelectedDownloadColumns() {
    const discoverytype = this._route.snapshot.params['discoverytype'];
    let localStorageKey = LOCALSTORAGE_KEY;
    if (discoverytype === 'domains') {
      localStorageKey = LOCALSTORAGE_KEY_DOMAINS;
    }
    const lsValue = localStorage.getItem(localStorageKey);
    if (lsValue) {
      const lsValueArr = lsValue.split(',');
      lsValueArr.forEach(value => {
        const foundColumn = this.downloadColumns.filter(
          column => column.key === value
        )[0];
        if (foundColumn) {
          foundColumn.selected = true;
          this.downloadButtonDisabled = false;
        }
      });
    }
  }

  prepareAppsData(docs: Array<any>) {
    docs.forEach((dataItem, index) => {
      this.currentConfig.gridHeaders.forEach(header => {
        const key = header.key;
        if (header.permission) {
          if (this._userService.hasPermission(header.permission)) {
            dataItem[key + 'HTML'] = this.getDataHTML(
              dataItem,
              header,
              `${index}`
            );
          } else {
            dataItem[key + 'HTML'] = '';
          }
        } else {
          dataItem[key + 'HTML'] = this.getDataHTML(
            dataItem,
            header,
            `${index}`
          );
        }
      });

      const website = UtilFunctions.toWebsiteURL(
        dataItem['developerWebsite'],
        validator
      );
      dataItem['developerWebsite'] = website;
    });
    return docs;
  }

  closeImportedFile() {
    if (this.currentConfig.key === 'apps') {
      this.currentConfig.mainFilterItems.forEach(mainFilter => {
        const configFilter = APP_MAIN_FILTERS.filter(
          filter => filter.apiKey === mainFilter.apiKey
        )[0];
        mainFilter.selected = JSON.parse(JSON.stringify(configFilter.selected));
        mainFilter.options = JSON.parse(JSON.stringify(configFilter.options));
      });
    } else if (this.currentConfig.key === 'ctv') {
      this.currentConfig.mainFilterItems.forEach(mainFilter => {
        const configFilter = CTV_MAIN_FILTERS.filter(
          filter => filter.apiKey === mainFilter.apiKey
        )[0];
        mainFilter.selected = JSON.parse(JSON.stringify(configFilter.selected));
        mainFilter.options = JSON.parse(JSON.stringify(configFilter.options));
      });
    }

    this.bulkUploadReportId = null;
    this.routeRefresh({ bulkUploadReportId: null });
  }

  closeFollowing() {
    if (this.currentConfig.key === 'apps') {
      this.currentConfig.mainFilterItems.forEach(mainFilter => {
        const configFilter = APP_MAIN_FILTERS.filter(
          filter => filter.apiKey === mainFilter.apiKey
        )[0];
        mainFilter.selected = JSON.parse(JSON.stringify(configFilter.selected));
        mainFilter.options = JSON.parse(JSON.stringify(configFilter.options));
      });
    } else if (this.currentConfig.key === 'ctv') {
      this.currentConfig.mainFilterItems.forEach(mainFilter => {
        const configFilter = CTV_MAIN_FILTERS.filter(
          filter => filter.apiKey === mainFilter.apiKey
        )[0];
        mainFilter.selected = JSON.parse(JSON.stringify(configFilter.selected));
        mainFilter.options = JSON.parse(JSON.stringify(configFilter.options));
      });
    } else if (this.currentConfig.key === 'domains') {
      this.currentConfig.mainFilterItems.forEach(mainFilter => {
        const configFilter = DOMAIN_MAIN_FILTERS.filter(
          filter => filter.apiKey === mainFilter.apiKey
        )[0];
        mainFilter.selected = JSON.parse(JSON.stringify(configFilter.selected));
        mainFilter.options = JSON.parse(JSON.stringify(configFilter.options));
      });
    }

    this.showFollowing = false;
    this.routeRefresh({ showFollowing: null });

    this.updatePageTitle();
  }

  followingClick(event?: any) {
    this.initializeAsAllOptions();
    this.routeRefresh({ showFollowing: 'true' });
  }

  async unfollowItem(dataItem: any) {
    jQuery('*[title]').tooltip('hide');
    let appId = dataItem.appId;
    const type = this.currentConfig.key;
    this.totalCount -= 1;
    if (this.currentConfig.key === 'apps' || this.currentConfig.key === 'ctv') {
      appId = dataItem.appId;
      this.gridData = this.gridData.filter(item => item.appId !== appId);
    } else if (this.currentConfig.key === 'domains') {
      appId = dataItem.domain;
      this.gridData = this.gridData.filter(item => item.domain !== appId);
    }
    this.followingCount -= 1;
    await this._watchlistService.removeFollow(
      appId,
      type,
      dataItem.device,
      true
    );
    this._eventService.updateEyeNumFollowing.emit(true);
  }

  initHovers() {
    setTimeout(() => {
      jQuery('.domain-cell img').mouseenter($event => {
        jQuery($event.target).parent().next().addClass('asTooltip');
        let rect = jQuery($event.target)[0].getBoundingClientRect();
        let dWidth = jQuery($event.target).parent().next().outerHeight();
        let topLoc = rect.top - dWidth - 20;
        let leftLoc = rect.left;
        jQuery($event.target)
          .parent()
          .next()
          .css('top', topLoc + 'px');
        jQuery($event.target)
          .parent()
          .next()
          .css('left', leftLoc + 'px');
      });

      jQuery('.domain-cell img').mouseleave($event => {
        jQuery($event.target).parent().next().removeClass('asTooltip');
      });
    }, 100);
  }

  initAppHovers() {
    setTimeout(() => {
      jQuery('.aptitleCont img').mouseenter($event => {
        jQuery($event.target).parent().next().addClass('asTooltip');
        const rect = jQuery($event.target)[0].getBoundingClientRect();
        const dWidth = jQuery($event.target).parent().next().outerHeight();
        const topLoc = rect.top - dWidth - 20;
        const leftLoc = rect.left;
        jQuery($event.target)
          .parent()
          .next()
          .css('top', topLoc + 'px');
        jQuery($event.target)
          .parent()
          .next()
          .css('left', leftLoc + 'px');
      });

      jQuery('.aptitleCont img').mouseleave($event => {
        jQuery($event.target).parent().next().removeClass('asTooltip');
      });
    }, 100);
  }

  initDomainLinks() {
    setTimeout(() => {
      jQuery('.domain-link').on('click', event => {
        event.stopPropagation();
        if (jQuery('div.details-overlay-transition-message').length <= 0) {
          if (this._userService.domainEnabled()) {
            const classList = jQuery(event.target).attr('class').split(' ');
            let region = classList
              .filter(cl => cl.indexOf('region-') >= 0)[0]
              .replace('region-', '');
            if (region === 'Non') {
              region = 'NON-US';
            }
            const device = classList
              .filter(cl => cl.indexOf('device-') >= 0)[0]
              .replace('device-', '');
            const domainid = classList
              .filter(cl => cl.indexOf('id-') >= 0)[0]
              .replace('id-', '');
            const domain = classList
              .filter(cl => cl.indexOf('domainname-') >= 0)[0]
              .replace('domainname-', '');
            const section = classList
              .filter(cl => cl.indexOf('section-') >= 0)[0]
              .replace('section-', '');
            const appIconElement = jQuery(`img.domainIcon.id-${domainid}`)[0];
            const rect = UtilFunctions.focusLogo(appIconElement);
            this._domainService.getAvailableMonths().then(months => {
              this._domainService.setRegion(region);
              this._domainService.setDevice(device);
              this._domainService.getAllData(domain).then(res => {
                this._domainService.storeDomainIconCoordinates(rect);
                this._domainService.storeDomainDetailsCache(domain, res);
                setTimeout(() => {
                  jQuery('.details-overlay-transition').remove();
                }, 500);
                this._router.navigate(
                  ['/insight/domains/', domain, region, device],
                  { queryParams: { section: `#${section}` } }
                );
                jQuery('div.details-overlay-transition-message').remove();
              });
            });
          } else {
            this._eventService.showPopupEvent.emit(true);
          }
        }
      });
    }, 300);
  }

  initAppLinks() {
    setTimeout(() => {
      jQuery('.app-link').on('click', event => {
        event.stopPropagation();
        if (jQuery(event.target).text() !== 'N/A') {
          if (jQuery('div.details-overlay-transition-message').length <= 0) {
            if (this._userService.appEnabled()) {
              const classList = jQuery(event.target).attr('class').split(' ');
              let region = classList
                .filter(cl => cl.indexOf('region-') >= 0)[0]
                .replace('region-', '');
              const device = classList
                .filter(cl => cl.indexOf('device-') >= 0)[0]
                .replace('device-', '');
              const appid = classList
                .filter(cl => cl.indexOf('appid-') >= 0)[0]
                .replace('appid-', '');
              const indexid = classList
                .filter(cl => cl.indexOf('id-') >= 0)[0]
                .replace('id-', '');
              const store = classList
                .filter(cl => cl.indexOf('store-') >= 0)[0]
                .replace('store-', '');
              const section = classList
                .filter(cl => cl.indexOf('section-') >= 0)[0]
                .replace('section-', '');
              const appIconElement = jQuery(`img.appIcon.id-${indexid}`)[0];
              const rect = UtilFunctions.focusLogo(appIconElement);
              if (region === 'North') {
                region = 'NA';
              }
              this._appService.setDevice(device);
              this._appService.setOs(store);
              this._appService.setRegion(region);
              this._appService.getAvailableMonths().then(months => {
                this._appService.getAllData(appid).then(res => {
                  this._appService.storeAppIconCoordinates(rect);
                  setTimeout(() => {
                    jQuery('.details-overlay-transition').remove();
                  }, 1000);
                  this._router.navigate(
                    ['/insight/apps/', appid, region, store, device],
                    {
                      queryParams: { section: `#${section}` }
                    }
                  );
                  jQuery('div.details-overlay-transition-message').remove();
                });
              });
            } else {
              this._eventService.showPopupEvent.emit(true);
            }
          }
        }
      });
    }, 300);
  }

  initCtvLinks() {
    setTimeout(() => {
      jQuery('.ctv-link').on('click', event => {
        event.stopPropagation();
        if (jQuery(event.target).text() !== 'N/A') {
          if (jQuery('div.details-overlay-transition-message').length <= 0) {
            if (this._userService.ctvEnabled()) {
              const classList = jQuery(event.currentTarget)
                .attr('class')
                .split(' ');
              let region = classList
                .filter(cl => cl.indexOf('region-') >= 0)[0]
                .replace('region-', '');
              const device = classList
                .filter(cl => cl.indexOf('device-') >= 0)[0]
                .replace('device-', '');
              const appid = classList
                .filter(cl => cl.indexOf('appid-') >= 0)[0]
                .replace('appid-', '');
              const indexid = classList
                .filter(cl => cl.indexOf('id-') >= 0)[0]
                .replace('id-', '');
              const section = classList
                .filter(cl => cl.indexOf('section-') >= 0)[0]
                .replace('section-', '');
              const appIconElement = jQuery(`img.appIcon.id-${indexid}`)[0];
              const rect = UtilFunctions.focusLogo(appIconElement);
              if (region === 'North') {
                region = 'NA';
              }
              this._ctvService.setDevice(device);
              this._ctvService.setRegion(region);
              this._ctvService.getAvailableMonths().then(months => {
                this._ctvService.getAllData(appid).then(res => {
                  this._ctvService.storeAppIconCoordinates(rect);
                  setTimeout(() => {
                    jQuery('.details-overlay-transition').remove();
                  }, 1000);
                  this._router.navigate(
                    ['/insight/ctv/', appid, region, device],
                    {
                      queryParams: { section: `#${section}` }
                    }
                  );
                  jQuery('div.details-overlay-transition-message').remove();
                });
              });
            } else {
              this._eventService.showPopupEvent.emit(true);
            }
          }
        }
      });
    }, 300);
  }

  initDiscoveryLinks() {
    setTimeout(() => {
      jQuery('.discovery-link').on('click', event => {
        event.stopPropagation();
        if (jQuery(event.target).text() !== 'N/A') {
          const classList = jQuery(event.target).attr('class').split(' ');
          const param = classList
            .filter(cl => cl.indexOf('discovery-param-') >= 0)[0]
            .replace('discovery-param-', '');
          let value = jQuery(event.target).text();
          const foundValue = classList.filter(
            cl => cl.indexOf('discovery-param-value-') >= 0
          )[0];
          if (foundValue) {
            value = foundValue.replace('discovery-param-value-', '');
          }
          let foundTabGroup = null;
          this.currentConfig.topLevelCategories.forEach(topLevelCategory => {
            topLevelCategory.groups.forEach(group => {
              group.items.forEach(tabbedGroupItem => {
                if (tabbedGroupItem.param === param) {
                  foundTabGroup = group;
                }
              });
            });
          });

          const foundTabFilter = foundTabGroup
            ? foundTabGroup.items.filter(item => item.param === param)[0]
            : null;
          if (foundTabFilter) {
            const option: DropdownSelectItem = {
              text: foundTabFilter.label,
              value: value
            };

            jQuery('*[title]').tooltip('hide');

            const foundSelected = this.selectedFilterValues.filter(
              filterValue => filterValue.param === param
            )[0];
            if (!foundSelected) {
              this.onDropdownFilterSelectInvoker.emit({
                tabbedFilterItem: foundTabFilter,
                option: option,
                event: null
              });
            }
          }
        }
      });
    }, 300);
  }

  initGridHeaders() {
    const deviceFilter = this.currentConfig.mainFilterItems.filter(
      mainFilter => mainFilter.apiKey === 'device'
    )[0];
    const ctvDevice =
      deviceFilter && deviceFilter.selected
        ? deviceFilter.selected.value
        : null;
    this.currentConfig.gridHeaders.forEach(gridHeader => {
      if (this.currentConfig.key === 'ctv') {
        if (gridHeader.key === 'isCvaaCompliant') {
          if (ctvDevice === 'roku') {
            gridHeader.hidden = false;
          } else {
            gridHeader.hidden = true;
          }
        }
      }
    });
  }

  initTooltips() {
    setTimeout(() => {
      jQuery('*[title]').tooltip({
        container: 'body',
        html: true,
        animation: false,
        trigger: 'hover'
      });
    }, 200);
  }

  getDataHTML(dataItem: any, header: GridHeader, indexId: string) {
    try {
      return UtilFunctions.getDataHTML(
        dataItem,
        header,
        this.currentConfig.gridHeaders,
        this._userService
      );
    } catch (e) {
      console.log('error: ', e);
      console.log('dataitem: ', dataItem);
      console.log('header: ', header);
      console.log('indexId: ', indexId);
    }
  }

  selectTab(tab: TabbedFilterGroup) {
    this.selectedTabbedGroup = tab;
    this.currentConfig.topLevelCategories.forEach(topLevelCategory => {
      topLevelCategory.groups.forEach(item => {
        item.selected = tab.label === item.label;
      });
    });
  }

  fetchFacets() {
    const filterStrings = this.getFilterStrings(false, true);
    if (this.showFollowing) {
      filterStrings.push(
        `userId=${this._userService.getIdentity().userEmailAddress}`
      );
    }
    let foundParam = false;
    this.selectedFilterValues.forEach(x => {
      if (x.param === this._appService.excludeFacetParam) {
        foundParam = true;
      }
    });
    let service = null;
    if (this.currentConfig.key === 'apps') {
      if (this.appGlobalSearchParam && this.appGlobalSearchParam.length > 0) {
        filterStrings.push(`appGlobalSearchParam=${this.appGlobalSearchParam}`);
      }
      service = this._appService.getFacets(filterStrings.join('&'));
    } else if (this.currentConfig.key === 'domains') {
      service = this._domainService.getFacets(filterStrings.join('&'));
    } else if (this.currentConfig.key === 'ctv') {
      service = this._ctvService.getFacets(filterStrings.join('&'));
    }

    if (service !== null) {
      service.then(response => {
        const newFacets = response['facets'];
        if (newFacets) {
          const facetsCopy = JSON.parse(JSON.stringify(this.facets));
          const facetKeys = Object.keys(newFacets);
          for (const key of facetKeys) {
            const facetItems = newFacets[key];
            if (
              key !== this._appService.excludeFacetParam ||
              (key === this._appService.excludeFacetParam && !foundParam)
            ) {
              const sellerMapping = {};
              const sellerNameKeys = [];
              if (facetItems && facetItems.length > 0) {
                for (const sellerName of facetItems) {
                  const keys = Object.keys(sellerName);
                  const name = keys[0];
                  sellerNameKeys.push(name);
                  const value = sellerName[name];
                  sellerMapping[name] = value;
                }
              }
              facetsCopy[key] = sellerMapping;
            }
          }
          this.facets = facetsCopy;

          this._eventService.updateEyeNumFollowing.emit(true);
        }
      });

      this.currentConfig.topLevelCategories.forEach(topLevelCategory => {
        topLevelCategory.groups.forEach(tabbedGroup => {
          tabbedGroup.items
            .filter(item => !item.hideSearch)
            .forEach(item => {
              if (
                item.type === 'dropdown' &&
                !item.hideSearch &&
                item.options.length > 0
              ) {
                this.showOptionsInvoker.emit({
                  tabbedFilterItem: item,
                  forceRefresh: true
                });
              }
            });
        });
      });
    }
  }

  removedSelectedFilterValue(
    selectedValue: TabbedFilterItemValue,
    event?: any
  ) {
    if (event) {
      event.stopPropagation();
    }
    if (!this.loadingData) {
      const item = {
        tab: null,
        text: null,
        param: selectedValue.param,
        iconHtml: null,
        values: [selectedValue.value],
        aggregate: false
      };
      this._clearFilterService.confirmclearFilter(item);
      const filterValues = [];
      this.selectedFilterValues.forEach(filterValue => {
        if (
          filterValue.param === selectedValue.param &&
          filterValue.value === selectedValue.value
        ) {
          // Do Nothing
        } else {
          filterValues.push(filterValue);
        }
      });

      this.currentConfig.topLevelCategories.forEach(topLevelCategory => {
        topLevelCategory.groups.forEach(tabbedGroup => {
          const foundTabItem = tabbedGroup.items.filter(
            titem => titem.param === selectedValue.param
          )[0];
          if (foundTabItem) {
            const foundOption = foundTabItem.options.filter(
              option => option.value === selectedValue.value
            )[0];
            if (foundOption) {
              foundOption.selected = false;
            }
          }
        });
      });

      this._appService.excludeFacetParam = selectedValue.param;
      setTimeout(() => {
        this.routeWithFilterValues(filterValues);
      }, 100);
    }
  }

  routeWithFilterValues(filterValues: TabbedFilterItemValue[]) {
    let queryParams = {};
    if (filterValues && filterValues.length > 0) {
      filterValues.forEach(filterValue => {
        if (queryParams[filterValue.param]) {
          queryParams[filterValue.param] += '()' + filterValue.value;
        } else {
          queryParams[filterValue.param] = filterValue.value;
        }
      });
    }

    this.bulkUploadReportId =
      this._route.snapshot.queryParams['bulkUploadReportId'];
    if (this.bulkUploadReportId) {
      queryParams['bulkUploadReportId'] = this.bulkUploadReportId;
    }

    if (this.appGlobalSearchParam && this.appGlobalSearchParam.length > 0) {
      queryParams['appGlobalSearchParam'] = this.appGlobalSearchParam;
    }

    this.routeRefresh(queryParams);
  }

  clearAllSelectedFilters() {
    if (this.selectedFilterValues && this.selectedFilterValues.length > 0) {
      this.selectedFilterValues.forEach(value => {
        let values = [];
        values.push(value.value);
        let item = {
          tab: null,
          text: null,
          param: value.param,
          iconHtml: null,
          values: values,
          aggregate: false
        };

        this._clearFilterService.confirmclearFilter(item);
      });
    }
    this.routeWithFilterValues(null);
  }

  toggleSort(selectedGridHeader: GridHeader) {
    if (selectedGridHeader.sortColumnKey && !this.loadingData) {
      this.currentConfig.gridHeaders.forEach(gridHeader => {
        if (gridHeader.key === selectedGridHeader.key) {
          const sort = gridHeader.sort;
          if (sort === '') {
            gridHeader.sort = 'sort-desc';
            if (
              gridHeader.sortColumnKey === 'appTitle' ||
              gridHeader.sortColumnKey === 'domain'
            ) {
              gridHeader.sort = 'sort-asc';
            }
          } else if (sort === 'sort-desc') {
            gridHeader.sort = 'sort-asc';
            if (
              gridHeader.sortColumnKey === 'appTitle' ||
              gridHeader.sortColumnKey === 'domain'
            ) {
              gridHeader.sort = '';
            }
          } else {
            gridHeader.sort = '';
            if (
              gridHeader.sortColumnKey === 'appTitle' ||
              gridHeader.sortColumnKey === 'domain'
            ) {
              gridHeader.sort = 'sort-desc';
            }
          }
        } else {
          gridHeader.sort = '';
        }
      });

      this.gridData = [];
      this.showLoadMore = false;
      this.showLoadingMore = false;
      this.loadDiscoveryData();
    }
  }

  loadMore() {
    this.showLoadingMore = true;
    this.loadDiscoveryData(false);
  }

  importCSVclick() {
    let isImportDisabled =
      (this.currentConfig.key === 'domains' &&
        !this._userService.domainBulkUploadEnabled()) ||
      (this.currentConfig.key === 'apps' &&
        !this._userService.appBulkUploadEnabled()) ||
      (this.currentConfig.key === 'ctv' &&
        !this._userService.ctvBulkUploadEnabled());

    if (isImportDisabled) {
      this._eventService.showPopup();
    } else {
      this.toggleImportOptions(true);
      this.importCsvRemoveDuplicates = false;
      this.showImportParam = true;
    }
  }

  toggleImportOptions(selectAll: boolean) {
    const selectedImportParams = {
      ctv: {},
      apps: {},
      domains: {}
    };

    if (selectAll) {
      this.currentConfig.importParams.forEach(group => {
        if (group.type == 'checkbox') {
          const groupArr = group.options.map(option => option.value);
          selectedImportParams[this.currentConfig.key][group.key] = groupArr;
        } else {
          selectedImportParams[this.currentConfig.key][group.key] = ['T'];
        }
      });
    }

    this.selectedImportParams = selectedImportParams;
    this.importCsvRemoveDuplicates = selectAll;
  }

  updateImportParam(currentConfig: ReportConfig, group, option, checked?) {
    const selectedImportParams = this.selectedImportParams;
    let groupArr =
      this.selectedImportParams[currentConfig.key][group.key] || [];
    if (group.type === 'checkbox') {
      if (checked) {
        groupArr = [...groupArr, option.value];
      } else {
        groupArr = groupArr.filter(value => value != option.value);
      }
    } else if (group.type === 'radio') {
      groupArr = [option.value];
    }
    selectedImportParams[currentConfig.key][group.key] = groupArr;
    this.selectedImportParams = selectedImportParams;
  }

  proceedWithImport() {
    this.showImportParam = false;

    if (this.currentConfig.key === 'domains') {
      this.domainCSVClick();
    } else if (this.currentConfig.key === 'apps') {
      this.appCSVclick();
    } else if (this.currentConfig.key === 'ctv') {
      this.ctvCSVclick();
    }
  }

  processCheckImportQuotaResponse(keyString: string, res: any) {
    if (res['status'] === 401) {
      this._auth.logout();
    } else {
      const entity = res['accountBalance'].filter(
        f => f['Entity'] === keyString
      )[0];
      if (entity) {
        this.withCsvImportPermission = true;
        this.currentQuota = entity['Display Quota'];
        this.consumedQuota = entity['Consumed'];
        this.remainingQuota = entity['Display Remaining'];
        this.actualRemainingQuota = entity['Remaining'];
        this.quotaCount = entity['Display Quota'];
        this.quotaStartDate = this.datePipe.transform(
          entity['Quota Start Date'].split(' ')[0].replace(/-/g, '/'),
          'y-MM-dd'
        );
        this.quotaEndDate = this.datePipe.transform(
          entity['Quota End Date'].split(' ')[0].replace(/-/g, '/'),
          'y-MM-dd'
        );
      } else {
        this.withCsvImportPermission = false;
        this.currentQuota = 0;
        this.consumedQuota = 0;
        this.remainingQuota = 0;
        this.actualRemainingQuota = 0;
        this.quotaCount = 0;
      }
    }
  }

  computeAppQuota() {
    this._eventService.showFeedback();
    if (this._userService.appBulkUploadEnabled()) {
      this._appService.checkImportQuota().then(res => {
        this.processCheckImportQuotaResponse('App', res);
      });
    }
  }

  computeCtvQuota() {
    this._eventService.showFeedback();
    if (this._userService.ctvBulkUploadEnabled()) {
      this._ctvService.checkImportQuota().then(res => {
        this.processCheckImportQuotaResponse('CTV', res);
      });
    }
  }

  computeDomainQuota() {
    this._eventService.showFeedback();
    if (this._userService.domainBulkUploadEnabled()) {
      this._domainService.checkImportQuota().then(res => {
        this.processCheckImportQuotaResponse('Domain', res);
      });
    }
  }

  checkImportQuota() {
    const discoverytype = this._route.snapshot.params['discoverytype'];
    if (discoverytype === 'apps') {
      this.computeAppQuota();
    } else if (discoverytype === 'domains') {
      this.computeDomainQuota();
    } else if (discoverytype === 'ctv') {
      this.computeCtvQuota();
    }
  }

  appCSVclick() {
    this.computeAppQuota();
    setTimeout(() => {
      if (!this.withCsvImportPermission) {
        this._eventService.showPopup();
      } else if (this.actualRemainingQuota > 0) {
        jQuery('.csvFileUpload').trigger('click');
      } else {
        this.showQuotaExceeded = true;
      }
    }, 600);
  }

  ctvCSVclick() {
    this.computeCtvQuota();
    setTimeout(() => {
      if (!this.withCsvImportPermission) {
        this._eventService.showPopup();
      } else if (this.actualRemainingQuota > 0) {
        jQuery('.csvFileUpload').trigger('click');
      } else {
        this.showQuotaExceeded = true;
      }
    }, 600);
  }

  domainCSVClick() {
    this.computeDomainQuota();
    setTimeout(() => {
      if (!this.withCsvImportPermission) {
        this._eventService.showPopup();
      } else if (this.actualRemainingQuota > 0) {
        jQuery('.csvFileUpload').trigger('click');
      } else {
        this.showQuotaExceeded = true;
      }
    }, 600);
  }

  importCSV($event) {
    if (this.currentConfig.key === 'domains') {
      this.domainImportCSV($event);
    } else if (this.currentConfig.key === 'apps') {
      this.appImportCSV($event);
    } else if (this.currentConfig.key === 'ctv') {
      this.ctvImportCSV($event);
    }
  }

  getImportQueryParam() {
    const arrParam = [];
    this.currentConfig.importParams.forEach(element => {
      const arr =
        this.selectedImportParams[this.currentConfig.key][element.key];
      if (arr) {
        arrParam.push(`${element.key}=` + arr.join(','));
      }
    });
    return arrParam.join('&');
  }

  appImportCSV($event) {
    const formData = new FormData();
    formData.append('name', $event.target.files[0].name);
    formData.append('file', $event.target.files[0]);
    this.uploadingCsv = true;
    let props = {};
    this._tracking.eventTrack('initiate_app_bulk_upload', props);
    this._appService
      .importCSV(formData, this.getImportQueryParam())
      .then(res => {
        this.uploadingCsv = false;
        if (res['status'] === 200 || res['status'] === 'OK') {
          const bulkUploadReportId = res['bulkUploadReportId'];
          this._tracking.eventTrack(`initiate_app_bulk_succeeded`, props);
          $event.target.value = ''; // setting an empty value after to be able to upload again with the same file

          this.routeRefresh({ bulkUploadReportId: bulkUploadReportId });
          this.getImportStatus(bulkUploadReportId);
        } else if (res['status'] === 401) {
          props = {};
          this._tracking.eventTrack(
            'initiate_app_bulk_upload_failed_invalid_session',
            props
          );
        } else {
          if (res['status'] === 404) {
            this.errorMessage =
              'Apps count in the file exceeded the maximum limit (5000).';
          }
          props = {
            errorMessage: this.errorMessage
          };
          this._tracking.eventTrack(
            `initiate_app_bulk_upload_failed_server_error`,
            props
          );
          this.showServerError = true;
        }
      });
  }

  ctvImportCSV($event) {
    const formData = new FormData();
    formData.append('name', $event.target.files[0].name);
    formData.append('file', $event.target.files[0]);
    this.uploadingCsv = true;
    let props = {};
    this._tracking.eventTrack('initiate_ctv_bulk_upload', props);
    this._ctvService
      .importCSV(
        this.importCsvRemoveDuplicates,
        formData,
        this.getImportQueryParam()
      )
      .then(res => {
        this.uploadingCsv = false;
        if (res['status'] === 200 || res['status'] === 'OK') {
          const bulkUploadReportId = res['bulkUploadReportId'];
          this._tracking.eventTrack(`initiate_ctv_bulk_succeeded`, props);
          $event.target.value = ''; // setting an empty value after to be able to upload again with the same file

          this.routeRefresh({ bulkUploadReportId: bulkUploadReportId });
          this.getImportStatus(bulkUploadReportId);
        } else if (res['status'] === 401) {
          props = {};
          this._tracking.eventTrack(
            'initiate_ctv_bulk_upload_failed_invalid_session',
            props
          );
          this._router.navigate(['/Login']);
        } else {
          if (res['status'] === 404) {
            this.errorMessage =
              'Ctv count in the file exceeded the maximum limit (5000).';
          }
          props = {
            errorMessage: this.errorMessage
          };
          this._tracking.eventTrack(
            `initiate_app_bulk_upload_failed_server_error`,
            props
          );
          this.showServerError = true;
        }
      });
  }

  domainImportCSV($event) {
    const formData = new FormData();
    formData.append('name', $event.target.files[0].name);
    formData.append('file', $event.target.files[0]);
    this.uploadingCsv = true;
    let props = {};
    this._tracking.eventTrack('initiate_bulk_upload', props);
    this._domainService
      .importCSV(formData, this.getImportQueryParam())
      .then(res => {
        this.uploadingCsv = false;
        if (res['status'] === 200 || res['status'] === 'OK') {
          const bulkUploadReportId = res['bulkUploadReportId'];
          this._tracking.eventTrack(`initiate_bulk_upload_succeeded`, props);
          $event.target.value = ''; // setting an empty value after to be able to upload again with the same file
          this.routeRefresh({ bulkUploadReportId: bulkUploadReportId });
          this.getImportStatus(bulkUploadReportId);
        } else if (res['status'] === 401) {
          props = {};
          this._tracking.eventTrack(
            'initiate_bulk_upload_failed_invalid_session',
            props
          );
          this._router.navigate(['/Login']);
        } else {
          if (res['status'] === 404) {
            this.errorMessage =
              'Domains count in the file exceeded the maximum limit (5000).';
          }
          props = { errorMesage: this.errorMessage };
          this._tracking.eventTrack(
            `initiate_bulk_upload_failed_server_error`,
            props
          );
          this.showServerError = true;
        }
      });
  }

  getImportStatus(reportid: string) {
    this.showImportProgress = true;

    let importStart = this.importStartMap.get(reportid);
    if (importStart == undefined) {
      importStart = Date.now();
      this.importStartMap.set(reportid, importStart);
    } else if (Date.now() - importStart > this.maxTimeout) {
      this.importStartMap.delete(reportid);
      this.importErrorMessage =
        'The import is taking longer than expected, you may save this URL and check back later, or wait for the completion email notification. This URL will be valid for 7 days.';
      return;
    }

    this._appService
      .getImportStatus(reportid)
      .then(response => {
        if (response['status'] === 404) {
          this.importStartMap.delete(reportid);
          this.importErrorMessage = response['message'];
        } else {
          const status = response[reportid]['uploadData']['status'];
          if (status === 'Success') {
            setTimeout(() => {
              this.importStartMap.delete(reportid);
              this.showImportProgress = false;
              this.checkNotFound(response[reportid]['uploadData']);
              this.checkImportQuota();
              this.initializeImportFilterOptions(reportid);
            }, 100);
          } else if (status === 'Failed') {
            this.importStartMap.delete(reportid);
            this.importErrorMessage =
              response[reportid]['uploadData']['errMsg'];
          } else {
            setTimeout(() => {
              this.getImportStatus(reportid);
            }, 10000);
          }
        }
      })
      .catch(error => {
        this.importStartMap.delete(reportid);
        this.showImportProgress = false;
        console.log('ERROR:' + JSON.stringify(error));
        this.showServerError = true;
        this.routeRefresh({ bulkUploadReportId: null });
      });
  }

  initializeAsAllOptions() {
    if (this.currentConfig.key === 'apps') {
      this.currentConfig.mainFilterItems.forEach(mainFilter => {
        const configFilter = APP_MAIN_FILTERS.filter(
          filter => filter.apiKey === mainFilter.apiKey
        )[0];
        mainFilter.selected = JSON.parse(JSON.stringify(configFilter.selected));
        mainFilter.options = JSON.parse(JSON.stringify(configFilter.options));
      });

      // Set OS Option as all
      const appStoreFilter = this.currentConfig.mainFilterItems.filter(
        mainFilter => mainFilter.apiKey === 'appStore'
      )[0];
      const allOption = appStoreFilter.options.filter(
        option => option.value === 'all'
      )[0];
      appStoreFilter.options.forEach(option => (option.selected = false));
      appStoreFilter.selected = allOption;
      allOption.selected = true;
    } else if (this.currentConfig.key === 'ctv') {
      this.currentConfig.mainFilterItems.forEach(mainFilter => {
        const configFilter = CTV_MAIN_FILTERS.filter(
          filter => filter.apiKey === mainFilter.apiKey
        )[0];
        mainFilter.selected = JSON.parse(JSON.stringify(configFilter.selected));
        mainFilter.options = JSON.parse(JSON.stringify(configFilter.options));
      });

      // Set OS Option as all
      const appStoreFilter = this.currentConfig.mainFilterItems.filter(
        mainFilter => mainFilter.apiKey === 'device'
      )[0];
      const allOption = appStoreFilter.options.filter(
        option => option.value === 'all'
      )[0];
      appStoreFilter.options.forEach(option => (option.selected = false));
      appStoreFilter.selected = allOption;
      allOption.selected = true;
    } else if (this.currentConfig.key === 'domains') {
      // Set isSubDomain Option as T
      const appStoreFilter = this.currentConfig.mainFilterItems.filter(
        mainFilter => mainFilter.apiKey === 'isSubDomain'
      )[0];
      const allOption = appStoreFilter.options.filter(
        option => option.value === 'T'
      )[0];
      appStoreFilter.options.forEach(option => (option.selected = false));
      appStoreFilter.selected = allOption;
      allOption.selected = true;
    }
  }

  initializeImportFilterOptions(bulkUploadReportId: string) {
    let service = null;
    let mainFilters = null;

    if (this.currentConfig.key === 'apps') {
      service = this._appService.getImportFacets(bulkUploadReportId);
      mainFilters = APP_MAIN_FILTERS;
    } else if (this.currentConfig.key === 'ctv') {
      service = this._ctvService.getImportFacets(bulkUploadReportId);
      mainFilters = CTV_MAIN_FILTERS;
    } else if (this.currentConfig.key === 'domains') {
      service = this._domainService.getImportFacets(bulkUploadReportId);
      mainFilters = DOMAIN_MAIN_FILTERS;
    }

    service
      .then(response => {
        this.currentConfig.mainFilterItems.forEach(mainFilter => {
          const configFilter = mainFilters.filter(
            filter => filter.apiKey === mainFilter.apiKey
          )[0];
          if (!configFilter) return;

          const facetOptions = response['facets'][mainFilter.apiKey];
          if (!facetOptions) return;

          const selectedFacet =
            facetOptions.filter(
              facet => facet[mainFilter.selected.apiValue]
            )[0] || facetOptions[0];
          const selectedOptionKeys = Object.keys(selectedFacet);
          if (!selectedOptionKeys) return;

          const selectedOptionValue = selectedOptionKeys[0];
          const selectedOption =
            configFilter.options.filter(
              option => option.apiValue == selectedOptionValue
            )[0] || configFilter.options[0];

          mainFilter.selected = JSON.parse(JSON.stringify(selectedOption));
          mainFilter.options = JSON.parse(JSON.stringify(configFilter.options));
        });
      })
      .finally(() => {
        this.routeRefresh({ bulkUploadReportId: bulkUploadReportId });
        this.refreshData();
      });
  }

  checkNotFound(uploadData: any) {
    if (uploadData && uploadData['importedFileName']) {
      this.importedFileName = uploadData['importedFileName'];
    }

    this.notFoundCount = 0;

    if (
      uploadData['notFound'] &&
      uploadData['notFound'] > 0 &&
      uploadData['notFoundList'] &&
      uploadData['notFoundList'].length > 0
    ) {
      this.notFoundCount = uploadData['notFound'];
      this.notFoundList = uploadData['notFoundList'];
      this.notFoundListUri = uploadData['notFoundListUri'];

      let notFoundHTML = '';
      const topCount =
        uploadData['notFound'] < 25 ? uploadData['notFound'] : 25;
      let configKey = this.currentConfig.key;
      if (topCount === 1) {
        configKey = configKey.replace('s', '');
      }
      this.notFoundList.forEach(item => {
        notFoundHTML += `<div class='text-left not-found-list-item'>${item}</div>`;
      });

      if (this.notFoundCount > 25) {
        notFoundHTML += '<div class="text-left">Download to see more...</div>';
      }
      let ctvLabel = 'CTV app';
      if (this.notFoundCount > 1) {
        ctvLabel = 'CTV apps';
      }

      this.notFoundConfigKey = configKey === 'ctv' ? ctvLabel : configKey;
      this.notFoundListHTML = notFoundHTML;

      setTimeout(() => {
        jQuery('[data-toggle="tooltip"]').tooltip({
          container: 'body',
          html: true,
          animation: false,
          trigger: 'hover'
        });
      }, 500);
    }

    this._eventService.showFeedback();
  }

  savePreset() {
    if (this.savedPresetTitle) {
      this.savedPresetTitle = this.savedPresetTitle.trim();
      if (this.savedPresetTitle.length > 0) {
        const savedFilters = [];
        const otherFilters = [];
        this.selectedFilterValues.forEach(filterValue => {
          const otherFilter = {};
          otherFilter[filterValue.param] = filterValue.value;
          otherFilters.push(otherFilter);
        });
        const topFilters = {};
        this.currentConfig.mainFilterItems.forEach(mainFilterItem => {
          topFilters[mainFilterItem.apiKey] = mainFilterItem.selected.value;
        });
        let presetGroup = null;
        if (this.currentConfig.key === 'apps') {
          if (
            this.appGlobalSearchParam &&
            this.appGlobalSearchParam.length > 0
          ) {
            otherFilters.push({
              appGlobalSearchParam: this.appGlobalSearchParam
            });
          }

          presetGroup = 'appDiscovery';
        } else if (this.currentConfig.key === 'domains') {
          presetGroup = 'domainDiscovery';
        } else if (this.currentConfig.key === 'ctv') {
          presetGroup = 'ctvDiscovery';
        }
        if (presetGroup !== null) {
          const presetConfig = {
            abstract: {
              title: this.savedPresetTitle,
              group: presetGroup
            },
            reportConfig: {
              topFilters: topFilters,
              otherFilters: otherFilters
            }
          };
          this.savingPreset = true;
          this._appService
            .savePreset(presetConfig)
            .then(response => {
              this.savingPreset = false;
              if (response['reportId']) {
                this.showSavePreset = false;
              }
              this.presetsListInvoker.emit(true);
            })
            .catch(error => {
              toastr.error('Please try again next time.', 'Saving Failed!', {
                timeOut: 2000
              });
            });
        }
      }
    }
  }

  goBackToDiscovery() {
    this.importErrorMessage = '';
    this.showImportProgress = false;
    this.routeRefresh({ bulkUploadReportId: null });
  }

  updatePageTitle() {
    let title: string;
    if (this.showFollowing) {
      title = 'Watchlist - Pixalate Media Ratings Terminal';
      this.pageMeta.setInternalPageName('Watchlist');
    } else {
      title = 'Discovery - Pixalate Media Ratings Terminal';
      this.pageMeta.setInternalPageName('Discovery');
    }

    this._title.setTitle(title);
  }

  @HostListener('window:scroll', ['$event'])
  onScroll() {
    const scrollTop = jQuery(document).scrollTop();
    if (
      this.currentConfig &&
      (this.currentConfig.key === 'apps' || this.currentConfig.key === 'ctv')
    ) {
      const offsetTopRightInner = jQuery(
        '.right-content.discovery .right-content-inner'
      ).offset().top;
      if (scrollTop >= offsetTopRightInner) {
        jQuery(
          '.main-center-content .right-content.discovery.key-apps'
        ).addClass('sticky');
      } else {
        jQuery(
          '.main-center-content .right-content.discovery.key-apps'
        ).removeClass('sticky');
      }

      const resultsHeaderEl = jQuery(
        '.right-content.discovery .right-content-inner .results-header'
      );
      const offset = resultsHeaderEl ? jQuery(resultsHeaderEl).offset() : null;
      const resultsOffset = offset ? offset.top : 0;
      const resultsHeight = jQuery(resultsHeaderEl).outerHeight();
      const gridDataEl = jQuery('.right-content.discovery .grid-data');
      const griddataOffset =
        gridDataEl && gridDataEl.offset() ? gridDataEl.offset().top : 0;
      const headerHeight = jQuery(
        '.right-content.discovery .grid-header'
      ).outerHeight();
      const total = griddataOffset - headerHeight;
      if (scrollTop >= total) {
        jQuery('.right-content.discovery .right-content-inner').addClass(
          'sticky-header'
        );
      } else {
        jQuery('.right-content.discovery .right-content-inner').removeClass(
          'sticky-header'
        );
      }
    } else {
      const offset = jQuery('.right-content.discovery .grid-data').offset();
      if (offset) {
        const offsetTop = offset.top;
        const headerHeight = jQuery(
          '.right-content.discovery .grid-header'
        ).outerHeight();

        if (scrollTop >= offsetTop - headerHeight) {
          jQuery('.right-content.discovery').addClass('sticky');
        } else {
          jQuery('.right-content.discovery').removeClass('sticky');
        }
      }
    }
  }
}
